// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88445302","453":"25426bc6","455":"95e12404","977":"d51f05cd"}[chunkId] + ".chunk.js";
};